module.exports = {
	"articleTitle1": "Cupcake Station and Cake Nouveau indulge A2's sweet tooth",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Cupcake Station",
	"articleLink1": "https://www.michigandaily.com/content/decorative-desserts-cupcake-station-and-cake-noveau",
	"articleLink2": "https://www.michigandaily.com/content/2008-09-22/cupcakes",
	"articleSnippet1": "Oct 20, 2010 ... A walk inside Cupcake Station on East Liberty Street in Ann Arbor feels like a \nscene out of a Brothers Grimm fairytale: the hand-chalked sign ...",
	"articleSnippet2": "Sep 21, 2008 ... The Cupcake Station on East Liberty Street, which opened Friday, is part of a \nlarger trend taking the nation by storm. From The Little Cupcake ...",
	"foodRecommendations": [
		{
			"text": "Not anything special. It's your standard cupcake station",
			"person": "Charlie Ruiz"
		}
	],
	"articleTitle2": "New pastry shop brings chic cupcakes to Ann Arbor",
	"address": "116 E Liberty St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/leg/imagecache/fullnode/kep.BSIDE_.cupcake-station.4-18-13.0014..jpg",
			"author": "Katherine Pekala",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.279388,
		"lng": -83.747769
	},
	"totalMisc": 0,
	"categories": {
		"dessert": 1,
		"fooddrink": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/cupcakestation.json
// module id = 859
// module chunks = 0